/* eslint-disable react/jsx-no-useless-fragment */
import React, { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useCurrentWorkspace, useDefaultWorkspace } from '@hooks/workspace';

function HomePageRedirect() {
  const { workspaceId: workspaceIdParam } = useParams();
  const defaultWorkspace = useDefaultWorkspace(false);
  const [currentWorkspace, setCurrentWorkspace] = useCurrentWorkspace(false);
  const workspaceId =
    workspaceIdParam ?? currentWorkspace?.id ?? defaultWorkspace?.id;
  useEffect(() => {
    if (workspaceId) setCurrentWorkspace(workspaceId);
  }, [workspaceId, setCurrentWorkspace]);

  if (!currentWorkspace) return null;

  return <Navigate to={`/campaigns/all/${currentWorkspace.id}`} replace />;
}

export default HomePageRedirect;
